export default __webpack_public_path__ + "static/media/GAO RFID.22ce2c25.png";